export default __webpack_public_path__ + "static/media/plus-circle.a4304256.svg";